import { createAction, props } from '@ngrx/store';

export interface UserInfoFormData {
  firstName: string;
  lastName: string;
  email: string;
}

// Action Types
export const SUBMIT_USER_INFO = '[User Info] Submit Form';
export const SUBMIT_USER_INFO_SUCCESS = '[User Info] Submit Form Success';
export const SUBMIT_USER_INFO_FAILURE = '[User Info] Submit Form Failure';

// Action Creators
export const submitUserInfo = createAction(
  SUBMIT_USER_INFO,
  props<{ formData: UserInfoFormData }>()
);

export const submitUserInfoSuccess = createAction(
  SUBMIT_USER_INFO_SUCCESS,
  props<{ response: any }>()
);

export const submitUserInfoFailure = createAction(
  SUBMIT_USER_INFO_FAILURE,
  props<{ error: any }>()
); 